<div class="empty-panel"></div>

<div class="side-panel">

    <app-report-select></app-report-select>
    <form [formGroup]="searchForm" novalidate class="voffset-20" (ngSubmit)="onSubmit()">
        <div class="form-group form-horizontal">

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal ">
                        <label class="panel-label">{{ 'TransactionReport.DateFrom' | translate }}</label>
                        <bcui-date-picker-input2 class="date-picker" formControlName="dateFrom" name="dateFrom" hznTestId="transaction-report-date-from">
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'TransactionReport.DateTo' | translate }}</label>
                        <bcui-date-picker-input2 class="date-picker" formControlName="dateTo" name="dateTo" hznTestId="transaction-report-date-to">
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>

            <div class="voffset20">
                <div class="form-group form-horizontal">
                    <label class="panel-label">{{ 'TransactionReport.CampType' | translate }}</label>
                    <bcu-drop-down-multiselect-cf2 hznTestId="transaction-report-camp-type" [options]="campTypeDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onCampTypeChanged($event)">
                    </bcu-drop-down-multiselect-cf2>
                </div>
            </div>

            <div class="row d-flex align-items-end">
                <div class="col">
                    <button class="btn btn-primary pull-right" type="submit" hznTestId="transaction-report-search" [disabled]="!isFormValid()">{{'TransactionReport.Search' | translate}}</button>
                </div>
            </div>

        </div>
    </form>
</div>
